(() => {
  const config = window.ShopifyPWA || {};

  if (!('serviceWorker' in navigator) || !config.serviceWorkerUrl) {
    return;
  }

  const isLocalhost = /^(localhost|127(?:\.\d{1,3}){3})$/.test(window.location.hostname);

  if (window.location.protocol !== 'https:' && !isLocalhost) {
    return;
  }

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(config.serviceWorkerUrl, {
        scope: '/',
      });

      window.ShopifyPWA = {
        ...config,
        registration,
      };

      console.info('[PWA] service worker registered', registration.scope);
    } catch (error) {
      console.warn('[PWA] service worker registration failed', error);
    }
  });
})();
